<template>

<div id="s02section03" class="slide02-section-block">

  <div class="text-block">

    <Subtitle :text="$t('home.slide02.section03.title')"/>

    <div class="subtitle">
      <Common :text="$t('home.slide02.section03.subtitle')"/>
    </div>

    <SmallCommon :text="$t('home.slide02.section03.text')"/>

  </div>

  <div class="chart-block">
    <Fimage name="slide02section03.png"/>
  </div>

  <Arrow
    type="down"
    toType="page"
    toId="#slide03"
    :text="$t('home.slide02.section03.arrow')"/>

</div>

</template>

<script>
import Subtitle from '../../general/texts/Subtitle.vue'
import Common from '../../general/texts/Common.vue'
import SmallCommon from '../../general/texts/SmallCommon.vue'
import Fimage from '../../general/elements/Fimage.vue'
import Arrow from '../../general/elements/Arrow.vue'

export default {
  name: 'S02Section03',
  components: {
    Subtitle,
    Common,
    SmallCommon,
    Fimage,
    Arrow
  }
}
</script>

<style lang="scss" scoped>
</style>
